import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SaleComponent } from './sale.component';
import { AclGuard } from '@aes/acl';
import { AuthGuardService } from '@aes/core/core.module';
import { SaleNavigationHelper } from './sale-navigation-helper.provider';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: 'sale',
        component: SaleComponent,
        canActivate: [AuthGuardService, AclGuard],
        data: {
          roles: ['FUNC__FUNC_VIEW__SALE_DATA']
        },
        children: [
          {
            path: '',
            redirectTo: 'tickets',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            loadChildren: () => import('./sale-dashboard').then(m => m.SaleDashboardModule),
          },
          {
            path: 'payment-upload-history',
            loadChildren: () => import('./payment-history').then(m => m.PaymentHistoryModule),
          },
          {
            path: 'tickets',
            loadChildren: () => import('./data-list').then(m => m.DataListModule)
          },
          {
            path: 'sync-log',
            loadChildren: () => import('./sync-log').then(m => m.SyncLogModule)
          },
        ],
      },
    ]),
  ],
  exports: [RouterModule],
  declarations: [SaleComponent],
  providers: [SaleNavigationHelper]
})
export class SaleModule {}
